import { render, staticRenderFns } from "./OnboardingProfileBasic.vue?vue&type=template&id=1dd0bdc8&scoped=true&"
import script from "./OnboardingProfileBasic.vue?vue&type=script&lang=js&"
export * from "./OnboardingProfileBasic.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingProfileBasic.vue?vue&type=style&index=0&id=1dd0bdc8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd0bdc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
